// extracted by mini-css-extract-plugin
export default {"content":"CreateAccount_content__-uxfr","realContent":"CreateAccount_realContent__93UUt"};